import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=7ccb89c0&scoped=true&"
import script from "./DataDetail.vue?vue&type=script&lang=js&"
export * from "./DataDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=7ccb89c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb89c0",
  null
  
)

export default component.exports